import { render, staticRenderFns } from "./ClientApiKeys.vue?vue&type=template&id=3b8f71cd&scoped=true"
import script from "./ClientApiKeys.vue?vue&type=script&lang=js"
export * from "./ClientApiKeys.vue?vue&type=script&lang=js"
import style0 from "./ClientApiKeys.vue?vue&type=style&index=0&id=3b8f71cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8f71cd",
  null
  
)

export default component.exports